import React, { useEffect, useState } from 'react';
import { useNotionContext } from '../context';
import { formatDistance } from 'date-fns';
export var ExternalComponentAdobeXd = function (_a) {
    var original_url = _a.original_url, block = _a.block;
    var components = useNotionContext().components;
    var url = new URL(original_url);
    var _b = useState(url.pathname.substring(1)), name = _b[0], setName = _b[1];
    var _c = useState(''), username = _c[0], setUsername = _c[1];
    var _d = useState(), date = _d[0], setDate = _d[1];
    useEffect(function () {
        ;
        (block.format.attributes || []).forEach(function (att) {
            var _a;
            if (att.id == 'title') {
                setName(att.values[0]);
            }
            else if (att.id == 'username') {
                setUsername(att.values[0]);
            }
            else if (att.id == 'updated_at' && ((_a = att.values[0]) === null || _a === void 0 ? void 0 : _a.start_date)) {
                setDate(new Date(att.values[0].start_date));
            }
        });
    }, []);
    var content = (React.createElement("div", { style: {
            height: '300px'
        } }));
    return (React.createElement(components.link, { target: '_blank', rel: 'noopener noreferrer', href: original_url, style: {
            padding: '0px',
            borderRadius: '10px',
            border: '1px solid rgba(55, 53, 47, 0.09)'
        } },
        content,
        React.createElement("div", { className: 'notion-external-information', style: {
                padding: '10px',
                borderTop: '1px solid rgba(55, 53, 47, 0.09)'
            } },
            React.createElement("div", { className: 'notion-external-image' },
                React.createElement("img", { width: '33.744px', src: 'https://www.notion.so/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fpublic.notion-static.com%2F35ca0dbe-1985-4a73-baf8-2f2447315bb0%2FAdobe_XD_CC_icon.svg.png?userId=&cache=v2', alt: '' })),
            React.createElement("div", { className: 'notion-external-description' },
                React.createElement("div", { className: 'notion-external-title' }, name),
                React.createElement("div", { className: 'notion-external-subtitle' },
                    React.createElement("span", null, username),
                    date && (React.createElement(React.Fragment, null,
                        React.createElement("span", null, " \u2022 "),
                        React.createElement("span", null, formatDistance(date, new Date(), {
                            addSuffix: true
                        })))),
                    React.createElement(React.Fragment, null,
                        React.createElement("span", null, " \u2022 "),
                        React.createElement("span", null, "Adobe XD")))))));
};
//# sourceMappingURL=external-component-adobe-xd.js.map